var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{ref:"modal",attrs:{"title":"Subscribers","size":_vm.size}},[_c('subscribed-users-table',{attrs:{"account-id":_vm.accountId,"flat":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }